import { DateFormat, getLocalTimeZone, TimeFormat } from "@tournated-com/ui";
import { createContext } from "react";

export type DateFormatContextValue = {
  dateFormat: DateFormat;
  timeFormat: TimeFormat;
  timeZone: string;
  setDateFormat: (dateFormat: DateFormat) => void;
  setTimeFormat: (timeFormat: TimeFormat) => void;
  setTimeZone: (timeZone: string) => void;
};

export const DateFormatContext = createContext<DateFormatContextValue>({
  dateFormat: "european",
  timeFormat: "h24",
  timeZone: getLocalTimeZone(),
  setDateFormat: () => {},
  setTimeFormat: () => {},
  setTimeZone: () => {},
});
